import {AtomicWidgetContext} from './atomic.widget.context';
import {FormControl} from '@angular/forms';

export class StringWidgetContext extends AtomicWidgetContext<string> {
  static isEmpty(data) {
    if (typeof (data) === 'object') {
      if (JSON.stringify(data) === '{}' || JSON.stringify(data) === '[]') {
        return true;
      } else if (!data) {
        return true;
      }
      return false;
    } else if (typeof (data) === 'string') {
      return !data.trim();
    } else {
      return typeof (data) === 'undefined';
    }
  }

  private ctrl: FormControl;

  public initialize(): Promise<boolean> {
    return new Promise((resolve) => {
      this.ctrl = new StringControl(StringWidgetContext.isEmpty(this.model) ? null : this.model, this.getValidators());
      const controls = {};
      controls[this.groupId] = this.ctrl;
      this.createFormGroup(controls);
      resolve(true);
    });
  }

  updateModel(model: any) {
    this.ctrl.setValue(model);
  }
}

/**
 * Enforces numeric format.
 *
 * @author Wael Jammal
 */
class StringControl extends FormControl {

  setValue(value: any, options?: {
    onlySelf?: boolean;
    emitEvent?: boolean;
    emitModelToViewChange?: boolean;
    emitViewToModelChange?: boolean
  }): void {
    super.setValue(StringWidgetContext.isEmpty(value) ? null : value, options);
  }
}
